











































import Vue from "vue";
import Component from "vue-class-component";
import MapComponent from "../components/map/MapComponent.vue";
import NavDrawer from "@/components/layout/layout/NavDrawer.vue";
import NavBarComponent from "@/components/layout/layout/NavBarComponent.vue";
import SearchCard from "@/components/layout/layout/SearchCard.vue";
import ReconnectingEventSource from "reconnecting-eventsource";
import urls from "../web_client/urls";
import { targets, maps, features } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

@Component({
  components: {
    MapComponent,
    NavDrawer,
    NavBarComponent,
    SearchCard,
  },
})
export default class MainView extends Vue {
  //data
  sheet: boolean = false;
  tab: any = null;
  targetListener: any = null;

  atonListener: any = null;
  bsListener: any = null;


  //methods
  clickerHandler() {
    this.sheet = !this.sheet;
    if (!this.sheet) {
      targets.commit(MutationTypes.ERASE_SELECTED_TARGETS);
      features.commit(MutationTypes.ERASE_SELECTED_FEATURES);
    }
  }
  targetUpdater() {
    this.targetListener = new ReconnectingEventSource(urls.aisUrls.targets, {
      withCredentials: true,
    });
    this.targetListener.onmessage = (event: any) => {
      let data: any[] = JSON.parse(event.data);
      targets.commit(MutationTypes.SET_TARGETS, data);
    };
  }
  atonUpdater() {
    this.atonListener = new ReconnectingEventSource(urls.aisUrls.atons, {
      withCredentials: true,
    });
    this.atonListener.onmessage = (event: any) => {
      let data: any[] = JSON.parse(event.data);
      targets.commit(MutationTypes.SET_ATONS, data);
    };
  }
  bsUpdater() {
    this.bsListener = new ReconnectingEventSource(urls.aisUrls.basestations, {
      withCredentials: true,
    });
    this.bsListener.onmessage = (event: any) => {
      let data: any[] = JSON.parse(event.data);
      targets.commit(MutationTypes.SET_BS, data);
    };
  }
  deactivateMeasure() {
    if (maps.getters.measurementActivated) {
      maps.dispatch("activateMeasurement");
    }
  }

  //computed
  get targetsLoaded() {
    return targets.getters.targetsLoaded;
  }

  created() {
    this.targetUpdater();
    this.atonUpdater();
    this.bsUpdater();
  }
  beforeDestroy() {
    this.targetListener.close();
    this.atonListener.close();
    this.bsListener.close();
  }
}
